/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import { useSelector } from "react-redux";
import { Panel, PanelsBoard, KPIBoard, } from "vr-react-components";
import KPIWidgetFrontPanel from "../../../widgets/KPI/KPIWidgetFrontPanel";
import KPIWidgetSettings from "../../../widgets/KPI/KPIWidgetSettings";
import KPIWidgetInfo from "../../../widgets/KPI/KPIWidgetInfo";
import { handleSetKPI, handleSetSettings } from "../../../handlers/HomeRoomHandlers";

const LeftPanelVR = React.memo(({ width, height }) => {
    const data = useSelector((state) => state.homeroom.kpi);
    const canModify = useSelector((state) => state.private.device.canModify);

    return (
        <>
            <PanelsBoard
                panel
                title={data.opened ? "Selected KPI detail" : "KPI monitoring"}
                width={width / 2}
                height={height}
                aframeClasses={canModify ? "collidable" : ""}
                position={`${-width / 4} 0 0`}
                rotation="0 30 0"
            >
                {data.opened ?
                    <Panel aframeClasses={canModify ? "collidable" : ""}>
                        <a-entity position={`${width * 0.05 + 0.48} 1.42 0.001`}>
                            <a-circle
                                id="back"
                                class={canModify ? "collidable" : ""}
                                radius={height * 0.04}
                                color="#545454"
                                onClick={() => handleSetKPI(false)}
                                opacity={0.9}
                                animation__mouseenter_color={`property: color; to: #121212; easing: linear; startEvents: mouseenter; dur: 150`}
                                animation__mouseleave_color={`property: color; to: #545454; easing: linear; startEvents: mouseleave; dur: 150`}
                            />
                            <a-image
                                height={height * 0.05}
                                width={height * 0.05}
                                rotation="0 0 180"
                                position="0 0 0.001"
                                src="#Back"
                            />
                        </a-entity>
                        <KPIWidgetInfo
                            width={width * 0.45}
                            maxWidth={width * 0.45}
                            height={height * 0.9}
                            label={data && data.opened ? Object.keys(data.opened)[0] : null}
                            panel
                        />
                    </Panel> : <KPIBoard
                        tiles
                        data={data}
                        aframeClasses={canModify ? "collidable" : ""}
                        setKPI={handleSetKPI}
                        setSettings={handleSetSettings}
                        inVRMode={true}
                        FrontPanelWidget={KPIWidgetFrontPanel}
                        SettingsWidget={KPIWidgetSettings}
                        InfoWidget={KPIWidgetInfo}
                    />
                }
            </PanelsBoard>
        </>
    );
});

export default LeftPanelVR;